<template>
  <div :style="{ maxWidth: maxWidth }" class="tooltip">
    <template v-if="text !== null">
      {{ tr(text) }}
    </template>
    <slot v-else />
  </div>
</template>

<script>
  import { debounce, tr } from '~/assets/scripts/helpers'

  export default {
    name: 'Tooltip',
    props: {
      content: { type: String, default: 'MY TOOLTIP' },
      position: { type: String, default: 'above' },
      padding: { type: Number, default: 4 },
      text: { type: String, default: null },
      maxWidth: { type: String, default: `500px` },
    },
    emits: [`showing`, `hiding`],
    data() {
      return { visible: false }
    },
    watch: {
      visible: {
        handler: debounce(function (is_visible) {
          this.$el.style.display = 'block'
          if (is_visible) {
            this.show_tooltip()
            this.$el.style.opacity = '1'
          }
        }, 1),
      },
    },
    mounted() {
      this.parent_element = this.$el.parentElement
      this.parent_element.addEventListener('mouseenter', this.set_tooltip)
      this.parent_element.addEventListener('mouseleave', this.hide_tooltip)
    },
    beforeUnmount() {
      if (this.parent_element) {
        this.parent_element.removeEventListener('mouseenter', this.set_tooltip)
        this.parent_element.removeEventListener('mouseleave', this.hide_tooltip)
      }
      this.hide_tooltip()
    },
    methods: {
      tr,
      set_tooltip() {
        this.$emit(`showing`)
        this.visible = true
      },
      show_tooltip() {
        const rect = this.parent_element.getBoundingClientRect()
        let x = rect.x + rect.width / 2
        let y = rect.y + rect.height / 2

        if (this.position === 'left') {
          x = x - this.padding - rect.width / 2 - this.$el.offsetWidth
          y = y - this.$el.offsetHeight / 2
        } else if (this.position === 'right') {
          x = x + this.padding + rect.width / 2
          y = y - this.$el.offsetHeight / 2
        } else if (this.position === 'above') {
          x = x - this.$el.offsetWidth / 2
          y = y - this.padding - rect.height / 2 - this.$el.offsetHeight
        } else if (this.position === 'below') {
          x = x - this.$el.offsetWidth / 2
          y = y + this.padding + rect.height / 2
        }

        this.$el.style.left = x + 'px'
        this.$el.style.top = y + 'px'
      },
      hide_tooltip() {
        this.$emit(`hiding`)
        this.visible = false
        this.$el.style.display = 'none'
        this.$el.style.opacity = '0'
      },
    },
  }
</script>

<style scoped>
  .tooltip {
    background-color: rgba(0, 0, 0, 0.85);
    color: #fff;
    text-shadow: 0 0 3px black;
    text-align: center;
    border-radius: 6px;
    padding: 5px 8px;
    position: fixed;
    z-index: 10;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease-in;
  }
</style>
